module.exports = __webpack_public_path__ + "img/ken.ac6f9907.jpg";